<template>
  <div>
    <BaseModal :config="VestingModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
      <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
        <form ref="refVestingForm" id="VestingForm" action>
          <div id="pageErrors"
               class="alert alert-danger"
               v-if="pageErrors.length>0">
            <p>
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="error in pageErrors"
                    :key="error">{{ error }}</li>
              </ul>
            </p>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Program</label>
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchVestingProgram"
                  class="form-control"
                  :disabled="IsCorrection || editPendingCorrection"
                  v-model="VestingInfo.ProgramTitle"
                  :data-source="programAutoCompleteSource"
                  :data-text-field="'Title'"
                  :filter="'contains'"
                  :placeholder="'Search for Program'"
                  @select="onProgramAutoCompleteSelect"
                  @open="onProgramOpen"
                  @close="onProgramClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Partner</label>
              <div class="input-group mb-3 pl-0">
                <kendo-autocomplete
                  id="SearchVestingPartner"
                  class="form-control"
                  :disabled="IsCorrection || editPendingCorrection"
                  v-model="VestingInfo.ReceiverFullName"
                  :data-source="partnerAutoCompleteSource"
                  :data-text-field="'FullName'"
                  :filter="'contains'"
                  :placeholder="'Search for Partner'"
                  @select="onPartnerAutoCompleteSelect"
                  @open="onPartnerOpen"
                  @close="onPartnerClose"
                ></kendo-autocomplete>
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Unit Class</label>
              <div id="kendo-select">
                <kendo-dropdownlist v-model="VestingInfo.UnitClass"
                                    :data-source="ProgramUnitClassJsonData.option"
                                    :data-text-field="'UnitClass'"
                                    :option-label="'Select Unit Class'"
                                    :data-value-field="'UnitClass'"
                                    @select="onUnitClassSelect"
                                    name="Unit Class"
                                    @change="getUnits">
                </kendo-dropdownlist>   
              </div>
            </div>
            <div class="form-group col-md-6">
              <label>Unit Pool</label>
              <div id="kendo-select">
                <kendo-dropdownlist v-model="VestingInfo.UnitPool"
                                    :data-source="dropdowns.UnitPool.dataSource"
                                    :data-text-field="'Option'"
                                    :option-label="'Select Unit Pool'"
                                    :data-value-field="'Option'"
                                    @select="onUnitPoolSelect"
                                    name="Unit Pool">
                </kendo-dropdownlist>   
              </div>

            </div>
          </div>

          <div class="form-row">

            <div class="form-group col-md-6">
              <label class="required-label">Unit Type</label>
              <div id="kendo-select">
                <kendo-dropdownlist v-model="VestingInfo.UnitType"
                                    :data-source="dropdowns.UnitType.dataSource"
                                    :data-text-field="'Option'"
                                    :option-label="'Select Unit Type'"
                                    :data-value-field="'Option'"
                                    @select="onUnitTypeSelect"
                                    @change="getUnits"
                                    name="Unit Type">
                </kendo-dropdownlist>   
              </div>
            </div>
            <div class="form-group col-md-6">

              <label class="required-label">Vesting Type</label>
              <div id="kendo-select">
                <kendo-dropdownlist v-model="VestingInfo.VestingType"
                                    :data-source="dropdowns.VestingType.dataSource"
                                    :data-text-field="'Option'"
                                    :option-label="'Select Vesting Type'"
                                    :data-value-field="'Option'"
                                    name="Vesting Type"
                                    @select="onVestingTypeSelect"
                                    @change="getUnits">
                </kendo-dropdownlist>   
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label>Units</label>
              <input
                id="txtUnits"
                name="Units"
                disabled
                v-model="Units"
                class="form-control"
                placeholder="Units"
              >
            </div>
            
            <div class="form-group col-md-6">
              <label class="required-label">Vesting Date</label>
              <div class="input-group">
                <kendo-datepicker
                  placeholder="Select Date"  
                  :value='VestingInfo.VestedDate'
                  v-model='VestingInfo.VestedDate'
                  :format="'MM/dd/yyyy'" 
                  id="dtVestedDate"
                  width="100%"
                  @open="_setCurrentDateifNull"
                >
                </kendo-datepicker>
              </div>
            </div>

          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label class="required-label">Vesting Percentage</label>
              <input
                type="number"
                format="'p'"
                :disabled="IsCorrection || editPendingCorrection"
                id="txtPercentage"
                name="Percentage"
                min="0"
                max="100"
                @keyup="calcVestedUnit"
                @change="calcVestedUnit"
                v-model="VestingInfo.Percentage"
                class="form-control"
                placeholder="Percentage"
              >
            </div>
            <div class="form-group col-md-6">
              <label class="required-label">Vested Unit</label>
              <input
                type="number"
                id="txtVestedUnit"
                name="VestedUnits"
                min="0"
                @keyup="calcVestingPercent"
                @change="calcVestingPercent"
                v-model="VestingInfo.VestedUnit"
                class="form-control"
                placeholder="Vested Unit"
              >
            </div>

          </div>

          <div class="form-row">
            <div class="form-group col-md-12">
              <label v-bind:class="{ 'required-label': IsCorrection || editPendingCorrection }" >Note/Comment</label>
              <textarea
                class="form-control"
                v-model="VestingInfo.Note"
                rows="2"
                cols="50"
                id="txtNote"
                placeholder="Comments"
              ></textarea>
            </div>

          </div>
        </form>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
import BaseModal from "@/components/base/BaseModal.vue";
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";
import BaseModelVesting from "@/models/BaseModelVesting.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelCorrection from "@/models/BaseModelCorrection.js";
import BaseBusinessEventRunningTotal from "@/models/BaseBusinessEventRunningTotal.js";
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import { isNullOrUndefined } from 'util';
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";

export default {
  name: "VestingForm",
  watch: {
    VestingInfo: function(newVal) {
      this.VestingInfo.Percentage = (this.VestingInfo.Percentage * 100).toFixed(2);
    }
  },
  props: {
    VestingInfo: {},
    VestingModalLabel: {},
    ProgramUnitClassJsonData: {},
    IsCorrection:{default:false},
    editPendingCorrection:{default:false}
  },
  mixins: [apiUtil,funcUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter","getLocalInputControls"]),
    ...mapState("postModule", ["response"]),

  },
  data: function() {
    return {
      BaseModelVesting: BaseModelVesting,
      BaseModelProgram: BaseModelProgram,
      BaseModelPartner: BaseModelPartner,
      BaseModelUnitClass: BaseModelUnitClass,
      BaseModelCorrection:BaseModelCorrection,
      BaseModelTransactionLog : BaseModelTransactionLog,
      BaseBusinessEventRunningTotal: BaseBusinessEventRunningTotal,
      displayErrors: false,
      BaseModelInputControl: BaseModelInputControl,
      dropdowns: {
        UnitPool: { model: "", dataSource: [] },
        UnitType: { model: "", dataSource: [] },
        VestingType: { model: "", dataSource: [] },
        SpecialArrangement: { model:"", dataSource: [] }
      },
      programAutoCompleteSource: [],
      partnerAutoCompleteSource: [],
      bProgramValid: true,
      bPartnerValid: true,
      Units: 0,
      pageErrors:[],
      VestingUpdateConfig : {
        list: "Vesting",
        columns: {
          Id: {
          dataName: "Id",
          type: "number"
          },
          Status: {
          dataName: "Status",
          type: "string"
          }
        }
      }
    };
  },
  methods: {
    ...mapActions("postModule", ["UpdateItems", "CreateItems"]),
  
    onPartnerAutoCompleteSelect(e) {
      this.bPartnerValid = true;
      this.autocompleteValue = e.dataItem.Id;
      this.VestingInfo.ReceiverId = e.dataItem.Id;
      this.VestingInfo.ReceiverFullName = e.dataItem.FullName;
      this.getUnits();

    },
    onUnitClassSelect(e){
      this.VestingInfo.UnitClass = e.dataItem.UnitClass;

    },
    onUnitPoolSelect(e){
      this.VestingInfo.UnitPool = e.dataItem.UnitPool;

    },
    onVestingTypeSelect(e){
      this.VestingInfo.VestingType = e.dataItem.Option;

    },
    onUnitTypeSelect(e){
      this.VestingInfo.UnitType = e.dataItem.Option;

    },
    onPartnerOpen() {
      this.bPartnerValid = false;
    },
    onPartnerClose() {
      if (!this.bPartnerValid) {
        this.VestingInfo.ReceiverId = null;
        this.VestingInfo.ReceiverFullName = null;
      }
    },
    onProgramAutoCompleteSelect(e) {
      this.bProgramValid = true;
      this.autocompleteValue = e.dataItem.Id;
      this.VestingInfo.ProgramId = e.dataItem.Id;
      this.VestingInfo.ProgramTitle = e.dataItem.Title;

      this.getUnits();

      this.ProgramUnitClassJsonData.option= this.withFilter(BaseModelUnitClass.list, {filter: "ProgramId eq " + e.dataItem.Id});

      // we can remove this later, if we save it to actual sharepoint instead of DB.JSON
      this.VestingInfo.ProgramTitle = e.dataItem.Title;
      this.VestingInfo.ProgramAlias = e.dataItem.Alias;
      this.VestingInfo.ProgramEIN = e.dataItem.EIN;
      this.VestingInfo.ProgramFormationDate = e.dataItem.FormationDate;
      this.VestingInfo.ProgramFinalCloseDate = e.dataItem.FinalCloseDate;
      this.VestingInfo.ProgramMultiClass = e.dataItem.MultiClass;
      this.VestingInfo.ProgramIncomeSource = e.dataItem.IncomeSource;
      this.VestingInfo.ProgramStateSource = e.dataItem.StateSource;
    },
    onProgramOpen() {
      this.bProgramValid = false;
    },
    onProgramClose() {
      if (!this.bProgramValid) {
        this.VestingInfo.ProgramId = null;
        this.VestingInfo.ProgramTitle = null;
      }
    },

    async saveChanges(){
      this.displayErrors = true;
      const self=this;
      //this.$validator.validate().then(result => {
        if (this.Validate()) {
          if (this.VestingModalLabel.modalAddorEdit == "add") {
            // Add Popup
            this.VestingInfo.Status = "Pending";
            this.VestingInfo.BusinessEvent = "Vesting";
            console.log(JSON.stringify(this.VestingInfo));
            let addFormValues = {...this.VestingInfo}
            addFormValues.Percentage = Number(
              this.VestingInfo.Percentage / 100
            );

            //let loader = this.$loading.show();
            this._APICrudPopup("APICrudpopup");
            let createItem = { list:this.BaseModelVesting, payload:addFormValues };
            this.CreateItems(createItem).then(response => {
                  $("#vestingGrid").data().kendoGrid.dataSource.read();
                  this._AlertPopup("Data Saved Successfully!", "success");
                }).catch(error=>{
                  self._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                  //loader.hide();
                });
          } else {
            // Edit Popup
            console.log(JSON.stringify(this.VestingInfo));
            let editForm = this.VestingInfo;
            editForm.Percentage = Number(this.VestingInfo.Percentage / 100);
            //let loader;

            if (this.IsCorrection) {
                //alert("Correction ")
                //Logic for Saving to Correction List
                editForm.Status = "Pending"
                editForm.BusinessEvent = "Vesting"
                editForm.CorrectionID= editForm.Id;
                editForm.CorrectionDate = new Date();

                let userResponse=await this._ConfirmationPopup("Please confirm for creating correction for this record","confirm")
                if (userResponse.value) {
                //loader = this.$loading.show();
                this._APICrudPopup("APICrudpopup");
                let createItem = { list:this.BaseModelCorrection, payload:editForm };
                try {

                  let createResponse = await this.CreateItems(createItem);
                  //Update the Vesting List Status
                  editForm.Status = "Correction Pending"
                  let updateItem = { list:this.VestingUpdateConfig, payload:editForm };
                  if (createResponse) {
                    let updateResponse = await this.UpdateItems(updateItem);
                  } 
                  $("#vestingReportGrid").data().kendoGrid.dataSource.read();
                  this._AlertPopup("Correction created  Successfully!","success");
                } catch(error){
                  this._AlertPopup("Some Error occurred!", "info");
                }
                //loader.hide();
                }
                
            }else if(self.editPendingCorrection){
              //loader = this.$loading.show();
              this._APICrudPopup("APICrudpopup");
              let updateItem = { list:this.BaseModelCorrection, payload:editForm };
              this.UpdateItems(updateItem).then(response => {
                $("#CorrectionGrid").data().kendoGrid.dataSource.read();
                this._AlertPopup("Correction Edited Successfully!", "success");
                }).catch(error=>{
                  self._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                    $("#"+self.VestingModalLabel.modalIdandRef).modal("toggle");
                })
            }
            else{
              //loader = this.$loading.show();
              this._APICrudPopup("APICrudpopup");
              let updateItem = { list:this.BaseModelVesting, payload:editForm };
              this.UpdateItems(updateItem).then(response => {
              //(this.GridInfo.gridId) ? $("#"+this.GridInfo.gridId).data().kendoGrid.dataSource.read():$("#vestingGrid").data().kendoGrid.dataSource.read();
              $("#vestingGrid").data().kendoGrid.dataSource.read();
                this._AlertPopup("Data Saved Successfully!", "success");
                }).catch(error=>{
                  self._AlertPopup("Some Error Occurred!","info");
                }).finally(()=>{
                    //loader.hide();
                })
            }
            
          }
          
          $("#BaseModal").modal("toggle");
          this.resetFields();
        }
      //});
    },
    resetFields: function() {
      this.pageErrors = [];
    },
    getProgramAutoCompleteData() {

      this.programAutoCompleteSource = this.withFilter(BaseModelProgram.list);
    },
    getPartnerAutoCompleteData() {
       let partnerFilterQuery ={
		batchQuery:true,
        filter : function(o){
           return o.PartnerStatus !='Retired Employee' && o.PartnerStatus !='Former Employee'
        },
		limit: 5000
	}
      

      this.partnerAutoCompleteSource = this.withFilter(BaseModelPartner.list,partnerFilterQuery);

    },
    calcVestingPercent() {
      if (
        this.Units > 0 &&
        this.VestingInfo.VestedUnit != "" &&
        this.VestingInfo.VestedUnit != 0
      ) {
        this.VestingInfo.Percentage = (
          (this.VestingInfo.VestedUnit / this.Units) *100).toFixed(2);
      } else {
        this.VestingInfo.Percentage = 0.0;
      }
    },
    calcVestedUnit() {
      if (this.Units > 0 && this.VestingInfo.Percentage != "") {
        this.VestingInfo.VestedUnit =(this.Units * this.VestingInfo.Percentage) / 100;
      } else {
        this.VestingInfo.VestedUnit = 0;
      }
    },
    getUnits() {
      this.calculateUnits(this.VestingInfo);
    },
    calculateUnits(vestingInfo) {
      let self = this;
      if (self.IsCorrection || self.editPendingCorrection) {
        self.Units="Not Applicable"
        self.VestingInfo.Percentage=0.0;
        return;
      }
      self.Units = 0;
      let form = vestingInfo;
      //console.log(form)
      if (
        form.ProgramId &&
        form.ProgramTitle &&
        form.UnitClass != "" &&
        form.UnitType != "" &&
        form.VestingType!="" &&
        form.ReceiverId
      ) {
        //alert("Started Calculations")
        let filter = {
            filter: "ProgramId eq " + form.ProgramId
        }
        let response = this.withFilter(BaseModelTransactionLog.list,filter);

        // let response = this.withFilter(BaseBusinessEventRunningTotal.list, {
        //   filter: `BusinessEvent eq 'Issuance' and ProgramId eq ${
        //     form.ProgramId
        //   }`
        // });

       
        let filteredResponse = _.filter(response, function(item) {
          return (
            item.PartnerId == form.ReceiverId &&
            item.UnitClass == form.UnitClass &&
            item.UnitType == form.UnitType &&
            item.VestingType== form.VestingType
          );
        });
       //console.log(filteredResponse)
        if(filteredResponse && filteredResponse.length) {
          self.Units = _.sumBy(filteredResponse,function(data){
            return data.Unit
          });
          self.VestingInfo.Percentage=0.0
          self.VestingInfo.VestedUnit=0
        }
        // if (filteredResponse[0]) {
        //   self.Units = filteredResponse[0].Unit;
        //   //Reset the Vested Unit and Percentage Field 
        //   self.VestingInfo.Percentage=0.0
        //   self.VestingInfo.VestedUnit=0

        // }
      }
    },
    Validate() {
      const self = this;
      self.pageErrors = [];
      let form = self.VestingInfo;
      console.log(form);
      //Form Validations
      if (!(form.ProgramTitle && form.ProgramId)) {
        self.pageErrors.push("Program is required");
      }
      if (!(form.ReceiverFullName && form.ReceiverId)) {
        self.pageErrors.push("Partner is required");
      }
      //Unit Class
      if (form.UnitClass == "") {
        self.pageErrors.push("Unit Class is required");
      }
      //Unit Type
      if (form.UnitType == "") {
        self.pageErrors.push("Unit Type is required");
      }
      //Unit Type
      if (isNullOrUndefined(form.VestingType) || form.VestingType == "") {
        self.pageErrors.push("Vesting Type is required");
      }
      // if (form.SpecialArrangement == "") {
      //   self.pageErrors.push("Special Vesting is required");
      // }
      if (form.VestedDate == "" || form.VestedDate == null) {
        self.pageErrors.push("Vesting Date is required");
      }
      if (!(self.IsCorrection || self.editPendingCorrection) && (form.Percentage<=0 || form.Percentage>100)) {
        self.pageErrors.push("Vesting Percentage Should be greater than 0 and less than equal to 100");
      }
      if (!form.VestedUnit || form.VestedUnit <= 0) {
        self.pageErrors.push(
          "Vested Unit is Required and Should Be greater than 0"
        );
      } else if (!(self.IsCorrection || self.editPendingCorrection) && (form.VestedUnit > self.Units)) {
        self.pageErrors.push(
          "Vested Unit Cannot Be Greater Than Units"
        );
      }

      if ((self.IsCorrection || self.editPendingCorrection) && (form.Note=="" || isNullOrUndefined(form.Note))) {
        self.pageErrors.push("Note/Comments in Required for Correction");
      }
      if (self._validateSpecialCharacter(form.Note,"multiline")) {
        self.pageErrors.push(`Notes/Comments cannot have ${this.MultiLineSpecialChars}  Characters`);
      }
      // if(form.VestedUnit<=0 || form.VestedUnit>self.Units){
      //   self.pageErrors.push("Vesting Unit Should be Greater Than Zero and Less Than Units Field");
      // }

      return self.pageErrors.length > 0 ? false : true;
    },
    getInputControls() {
      let self = this;
      let response = self.getLocalInputControls(self.BaseModelInputControl.list);
      console.log(response)
        Object.keys(self.dropdowns).forEach(key => {
          self.dropdowns[key].dataSource = response[key];
          self.dropdowns[key].filter = self._setDropdownFilter(response[key]);
        });
      },
    },
  mounted() {
    
    this.getInputControls();
    this.ProgramUnitClassJsonData.option = this.withFilter(BaseModelUnitClass.list, '')
    this.resetFields();
    $("#BaseModal").on("shown.bs.modal", function() {
      $("input:text:visible:first", this).focus();
    });

    this.getProgramAutoCompleteData();
    this.getPartnerAutoCompleteData();

    //For Displaying List on Focus
    this.ShowAutoCompleteListOnFocus("SearchVestingProgram");
    this.ShowAutoCompleteListOnFocus("SearchVestingPartner");
  },
  components: {
    BaseModal
  }
};
</script>


<style scoped>
.k-widget.k-autocomplete.k-header.k-state-default {
  width: 250px;
  background-color: yellow;
}
/* input[type="radio"]{
  width: 22px;
  margin-top: 4px;
}*/
/* .addButtonClass{
  /* margin-left:70%; 
} */
</style>